import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { addQueryParamEpic } from './_epics/addQueryParam.epic';
import { removeQueryParamEpic } from './_epics/removeQueryParam.epic';
import { addQueryParamValueEpic } from './_epics/addQueryParamValue.epic';
import { removeQueryParamValueEpic } from './_epics/removeQueryParamValue.epic';
import { addLastPathParamEpic } from './_epics/addLastPathParam.epic';
import { removeLastPathParamEpic } from './_epics/removeLastPathParam.epic';
import { updateLastPathParamEpic } from './_epics/updateLastPathParam.epic';
import { pushEpic } from './_epics/push.epic';
import { replaceEpic } from './_epics/replace.epic';
import { clearLocationSateEpic } from './_epics/clearLocationState.epic';

export const routerEpic = safeCombineEpics(
  addQueryParamEpic,
  removeQueryParamEpic,
  addQueryParamValueEpic,
  removeQueryParamValueEpic,
  addLastPathParamEpic,
  removeLastPathParamEpic,
  updateLastPathParamEpic,
  pushEpic,
  replaceEpic,
  clearLocationSateEpic,
);
